import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { SESSION } from 'core/constants/endpoints'
import makePayload from './makePayload'

function sendApplicantContext(hcStorage, config) {
  return fetchJSONHandleError({
    url: `${SESSION}/applicantContext`,
    data: makePayload(hcStorage, config)
  })
}

export default sendApplicantContext
